/**
 * user mutations
 */
export const SET_SMS_CODE = 'SET_SMS_CODE';
export const STORE_USER = 'STORE_USER';

export const UPDATE_BUNDLES = 'UPDATE_BUNDLES';
export const UPDATE_STB = 'UPDATE_STB';
export const SET_CHECKOUT_DATA = 'SET_CHECKOUT_DATA';
export const SET_USE_PREPAID_STEPS = 'SET_USE_PREPAID_STEPS';
export const SET_IS_GENERAL_CHECKOUT = 'SET_IS_GENERAL_CHECKOUT';
export const SET_TERMS_ACCEPTED = 'SET_TERMS_ACCEPTED';

export const SET_LIMIT_CHECKOUT = 'SET_LIMIT_CHECKOUT';
export const SET_POST_BILL_CHECKOUT = 'SET_POST_BILL_CHECKOUT';
export const SET_INSURANCE_CHECKOUT = 'SET_INSURANCE_CHECKOUT';

/**
 * vuex mutation for Loader screen
 */
export const TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE = 'TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE';
export const TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE = 'TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE';

export const SET_CHECKED_LIMIT_AGREEMENT = 'SET_CHECKED_LIMIT_AGREEMENT';
export const SET_CHOSEN_TV = 'SET_CHOSEN_TV';
export const SET_CHOSEN_TV_TARIFF = 'SET_CHOSEN_TV_TARIFF';
export const SET_CHOSEN_TV_BONUS = 'SET_CHOSEN_TV_BONUS';
